import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        container: '[js-navigation="container"]',
        hamburger: '[js-navigation="hamburger"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initNav()
    }

    function initNav() {
        $(nodeSelectors.hamburger).on('click', function () {
            $(this).toggleClass('active')
            let body = $("html, body");
            body.stop().animate({scrollTop:0}, 100, 'swing');
            body.toggleClass('no-scroll')
            $(nodeSelectors.container).fadeToggle()
        })

        $(nodeSelectors.container + ' .menu-item-has-children').on('click', function (e) {
            $(this).toggleClass('active')
            $(this).find(' > .sub-menu').slideToggle()
        })
    }

    return Object.freeze({
        init,
    })
}